(function ($) {
  'use strict';

  /**
   * Custom Lists
   * - Forces `role="list"` on custom list classes to preserve accessibility
   *   (List style none)
   */

  // Add custom list classes here
  // - Scope to list els to ensure we don't catch fake lists
  var $custom_lists = $( 'ol, ul' )
    .filter( '.list--burger' );

  $custom_lists.each(function () {
    var $this = $(this);
    var this_role = $this.attr( 'role' );

    // Ensure `role` is _not_ set already
    if ( this_role !== undefined || this_role !== '' ) {
      $this.attr( 'role', 'list' );
    }
  });

})(jQuery);
